import { render, staticRenderFns } from "./organization.vue?vue&type=template&id=408631aa&scoped=true&"
import script from "./organization.vue?vue&type=script&lang=ts&"
export * from "./organization.vue?vue&type=script&lang=ts&"
import style0 from "./organization.vue?vue&type=style&index=0&id=408631aa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "408631aa",
  null
  
)

export default component.exports